<template>
  <van-popup v-model:show="visible" position="bottom" :round="true" :lock-scroll="true" class="transfer-confirm-popup">
    <div class="confirm-dialog bg-#fff rounded-t-16px overflow-hidden">
      <!-- 标题栏 -->
      <div class="flex items-center justify-center relative h-66px">
        <span class="text-18px text-#222 font-500">确认转赠</span>
        <div class="close-btn absolute right-16px w-24px h-24px flex items-center justify-center" @click="handleClose">
          <!-- <span class="text-25px text-999 font-100">×</span> -->
          <van-icon name="cross" size="18px" color="#999" />
        </div>
      </div>

      <!-- 内容区域 -->
      <div class="px-16px py-24px">
        <!-- 描述 -->
        <div class="text-14px text-#666 text-center">向{{ nickname }}用户转赠</div>

        <!-- 金额 -->
        <div class="text-36px text-#222 font-600 text-center mt-16px">
          <span class="text-24px">¥</span>
          <span>{{ amount }}</span>
        </div>

        <!-- 确认按钮 -->
        <div class="mt-100px">
          <van-button round block class="h-48px" :disabled="loading" :loading="loading" color="#FD7F5C" @click="handleConfirm">
            确认转赠
          </van-button>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script setup>
import { computed } from 'vue'
import { Popup as vanPopup } from 'vant'
import { useDebounceFn } from '@vueuse/core'

const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  nickname: {
    type: String,
    default: ''
  },
  amount: {
    type: Number,
    default: 0
  },
  loading: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:show', 'confirm', 'close'])

// 双向绑定
const visible = computed({
  get: () => props.show,
  set: val => emit('update:show', val)
})

// 关闭弹窗
const handleClose = () => {
  emit('update:show', false)
  emit('close')
}

// 确认转赠（防抖）
const handleConfirm = useDebounceFn(() => {
  emit('confirm')
}, 500)
</script>

<style lang="less" scoped>

</style>
